<template>
  <HpSidebar :id="id" title="Doctors In-Network">
    <aside class="drug-breakdown-sidebar my-7">
      <ul class="grid place-content-center gap-5">
        <li
          v-for="dr in quote.providerCoverage.providers"
          :key="dr.npi!"
          class="flex gap-1.5 text-2xl font-bold"
        >
          <div>
            <HpIcon v-if="dr.inNetwork" name="yes" class="size-8 text-success" />
            <HpIcon v-else class="size-8 text-danger" name="no" />
          </div>
          <span :class="dr.inNetwork ? 'text-success' : 'text-danger line-through'">
            {{ dr.name }}
          </span>
        </li>
      </ul>
    </aside>

    <template #footer>
      <div class="w-full border-t border-border pt-4">
        <div class="mx-auto grid w-full max-w-xs gap-2">
          <HpButton
            variant="secondary"
            icon="edit"
            @click.prevent="show('update-insurance-sidebar')"
          >
            <span>Edit or Add Doctors</span>
          </HpButton>
          <HpButton @click="hide(id)">Close</HpButton>
        </div>
      </div>
    </template>
  </HpSidebar>
</template>

<script lang="ts" setup>
  import { QuotedPlanVm } from '~/models/quoting/QuotedPlan'

  const props = defineProps<{
    id: string
    quote: QuotedPlanVm
  }>()

  const { show, hide } = DialogController.use()
</script>

<style scoped></style>
